import { FullStory } from '@fullstory/browser';

/**
 * Notify FullStory of the current page with proper title
 * Call this from component useEffect after the page title has been set
 *
 * @param title - The page title (from pageContext or serverData)
 */
export const notifyFullStoryPage = (title: string): void => {
    if (typeof window === 'undefined') {
        return;
    }

    try {
        const pageName = title || document.title;

        FullStory('setPage', {
            pageName,
        });
    } catch (error) {
        console.error('FullStory setPage failed:', error);
    }
};

/**
 * Set both document.title and notify FullStory
 * Use this for pages that need to set title client-side
 *
 * @param title - The page title to set
 */
export const setPageTitle = (title: string): void => {
    if (typeof window === 'undefined') {
        return;
    }

    if (title && document.title !== title) {
        document.title = title;
    }

    notifyFullStoryPage(title);
};
